import { Gltf, useBounds, useGLTF } from '@react-three/drei';
import { useEffect } from 'react';
import { Box3, Mesh, MeshStandardMaterial, Vector3 } from 'three';
import type { ModelProps } from '@hub/common/ModelViewer/ModelViewer';

export const GlbModel = ({ modelUrl, materialColor, setModelSize }: ModelProps) => {
  const bounds = useBounds();
  const { scene } = useGLTF(modelUrl);

  useEffect(() => {
    const box = new Box3().setFromObject(scene);
    const center = new Vector3();
    const size = new Vector3();
    box.getCenter(center);
    box.getSize(size);

    setModelSize(size);

    bounds?.refresh().reset().clip().fit();
  }, [scene, materialColor]);

  const changeModelColor = (color: string) => {
    scene.traverse(child => {
      if (child instanceof Mesh) {
        const meshChild = child as Mesh;
        meshChild.material = new MeshStandardMaterial({ color });
      }
    });
  };

  useEffect(() => {
    changeModelColor(materialColor);
  }, [materialColor, scene]);

  return <Gltf src={modelUrl} />;
};
